module.exports = __webpack_public_path__ + "media/images/opnioes/testmonial-vinicius-ferreira-17ff4ae67073b49352a030f9ca5ef7c9.png";